import React from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Row } from "@tanstack/react-table";

import { Download, EllipsisVertical, Pencil, Trash, X } from "lucide-react";
import { type Ticket } from "Stores/dashboardStore/tickets";
import { Utils } from "@/common/utils";

interface TableMenuProps {
	isOpen: boolean;
	toggleDropdown: (rowId: string | null) => void;
    row: Row<Ticket>;
    onDownloadPlan: (id: string) => void;
    onDeletePlan: (ticket: Ticket) => void;
    onToggleStatus?: (ticket: Ticket) => void;
    dashboardId?: number;
}

export default function TableMenu({ isOpen, row, onDeletePlan, onDownloadPlan, onToggleStatus, toggleDropdown, dashboardId }: TableMenuProps) {
    const isEditVisible: boolean = Utils.hasAdminAccess() || row.original.permissions.owner || row.original.permissions.assignee;
    const getPlanUrl = row.original.dashboard_id ? Utils.getActionplanUrl(row.original.dashboard, row.original.ruuid) : "";

    const isSameDashboard = row.original.dashboard_id === dashboardId;

    const canToggleStatus = row.original.type === "task" &&
                           row.original.permissions.can_edit_status &&
                           row.original.dashboard_id &&
                           !isSameDashboard;

    const isActionplanClosed = row.original.status === "closed";

    return (
		<Dropdown show={isOpen} onToggle={(isOpen, e) => {
				e.originalEvent?.preventDefault(),
				e.originalEvent?.stopPropagation(),
				toggleDropdown(row.id);
			}}
			className="table-options"
		>
            <Dropdown.Toggle tabIndex={0} className="toggle d-flex align-items-center">
                <div className="trailing-icon">
                    <EllipsisVertical size={20} />
                </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item as={"button"} className="d-flex align-items-center gap-2" onClick={() => onDownloadPlan(row.original.ruuid)}>
                    <span>
                        <Download />
                    </span>
                    Download
                </Dropdown.Item>

                {!isSameDashboard && isEditVisible ? (
					<Dropdown.Item as={"span"} id={`ap-edit-${row.original.ruuid}`} className="ap-edit__link">
						<Link to={getPlanUrl} className="d-flex align-items-center gap-2">
							<span>
								<Pencil />
							</span>
							Edit Details
						</Link>
                    </Dropdown.Item>
                ) : null}

                {canToggleStatus && onToggleStatus && !isActionplanClosed ? (
                    <Dropdown.Item as={"button"} className="d-flex align-items-center gap-2" onClick={() => onToggleStatus(row.original)}>
                        <span>
                            <X />
                        </span>
                        Close ActionPlan
                    </Dropdown.Item>
                ) : null}

                {Utils.isSuperAdmin() ? (
                    <Dropdown.Item as={"button"} className="d-flex align-items-center gap-2" onClick={() => onDeletePlan(row.original)}>
                        <span>
                            <Trash />
                        </span>
                        Delete
                    </Dropdown.Item>
                ) : null}
            </Dropdown.Menu>
        </Dropdown>
    );
}
